import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBarometricPressureIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 36,
	height: 28,
	viewBox: "0 0 36 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_3791_13610)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M9.31999 14.02C9.75999 14.47 10.39 14.69 11.22 14.66C12.05 14.63 12.65 14.31 13.03 13.7L19.19 3.66999L9.63999 10.15C9.06999 10.54 8.76999 11.18 8.72999 12.04C8.68999 12.91 8.88999 13.57 9.32999 14.02H9.31999ZM11.35 -9.76585e-06C12.43 -9.76585e-06 13.56 0.17999 14.74 0.54999C15.92 0.90999 17.05 1.53999 18.13 2.42999L16.65 3.51999C15.79 2.92999 14.88 2.48999 13.9 2.19999C12.92 1.90999 12.07 1.76999 11.35 1.76999C8.67999 1.76999 6.40999 2.75999 4.52999 4.72999C2.64999 6.70999 1.70999 9.09999 1.70999 11.91C1.70999 12.8 1.82999 13.69 2.06999 14.6C2.30999 15.51 2.64999 16.34 3.07999 17.11H19.59C20.01 16.4 20.34 15.57 20.59 14.63C20.84 13.68 20.96 12.76 20.96 11.85C20.96 11.02 20.84 10.13 20.6 9.16999C20.36 8.20999 19.94 7.32999 19.33 6.51999L20.44 4.97999C21.16 6.07999 21.7 7.18999 22.07 8.30999C22.43 9.41999 22.63 10.54 22.67 11.67C22.71 12.85 22.59 13.97 22.33 15.01C22.06 16.06 21.67 17.02 21.16 17.91C20.93 18.36 20.69 18.64 20.43 18.74C20.17 18.84 19.85 18.89 19.47 18.89H3.18999C2.86999 18.89 2.54999 18.81 2.22999 18.64C1.91999 18.47 1.67999 18.23 1.52999 17.92C1.03999 16.97 0.65999 16.01 0.38999 15.04C0.11999 14.06 -0.0100098 13.02 -0.0100098 11.92C-0.0100098 10.28 0.28999 8.73999 0.88999 7.28999C1.48999 5.83999 2.29999 4.57999 3.32999 3.49999C4.35999 2.42999 5.55999 1.56999 6.93999 0.93999C8.31999 0.30999 9.78999 -0.0100098 11.34 -0.0100098L11.35 -9.76585e-06Z",
				fill: "#1F3171"
			})
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_3791_13610",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 16,
			y: 9,
			width: 20,
			height: 20,
			children: /* @__PURE__ */ _jsx("rect", {
				x: 16,
				y: 9,
				width: 19.1668,
				height: 19.8108,
				fill: "#1F3171"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_3791_13610)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M26.5102 14.6678L26.1509 15.0154L26.5102 14.6678C26.26 14.4092 25.9394 14.2781 25.5819 14.2781C25.2244 14.2781 24.9037 14.4092 24.6535 14.6678C24.4042 14.9255 24.2832 15.2489 24.2832 15.6036V18.9054C24.2832 19.2601 24.4042 19.5835 24.6535 19.8412C24.9037 20.0998 25.2244 20.2308 25.5819 20.2308C25.9394 20.2308 26.26 20.0998 26.5102 19.8412C26.7595 19.5835 26.8805 19.2601 26.8805 18.9054V15.6036C26.8805 15.2489 26.7595 14.9255 26.5102 14.6678ZM26.5102 21.2714L26.1509 21.619L26.5102 21.2714C26.26 21.0128 25.9394 20.8817 25.5819 20.8817C25.2244 20.8817 24.9037 21.0128 24.6535 21.2714L25.0128 21.619L24.6535 21.2714C24.4042 21.5291 24.2832 21.8525 24.2832 22.2072C24.2832 22.5619 24.4042 22.8853 24.6535 23.143L25.0128 22.7953L24.6535 23.143C24.9037 23.4016 25.2244 23.5326 25.5819 23.5326C25.9394 23.5326 26.26 23.4016 26.5102 23.143L26.1509 22.7953L26.5102 23.143C26.7595 22.8853 26.8805 22.5619 26.8805 22.2072C26.8805 21.8525 26.7595 21.5291 26.5102 21.2714ZM25.5819 26.6599C24.5445 26.6599 23.576 26.4569 22.6709 26.0532C21.7559 25.6451 20.964 25.0934 20.291 24.3978C19.6179 23.7021 19.0825 22.8818 18.686 21.932C18.2935 20.9917 18.0957 19.9844 18.0957 18.9054C18.0957 17.8263 18.2935 16.819 18.686 15.8787C19.0825 14.929 19.6179 14.1087 20.291 13.413C20.964 12.7174 21.7559 12.1657 22.6709 11.7576C23.576 11.3539 24.5445 11.1509 25.5819 11.1509C26.6192 11.1509 27.5877 11.3539 28.4928 11.7576C29.4078 12.1657 30.1997 12.7174 30.8727 13.413C31.5458 14.1087 32.0812 14.929 32.4777 15.8787C32.8702 16.819 33.068 17.8263 33.068 18.9054C33.068 19.9844 32.8702 20.9917 32.4777 21.932C32.0812 22.8818 31.5458 23.7021 30.8727 24.3978C30.1997 25.0934 29.4078 25.6451 28.4928 26.0532C27.5877 26.4569 26.6192 26.6599 25.5819 26.6599Z",
				fill: "#1F3171",
				stroke: "#1F3171"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_3791_13610",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 22.68,
				height: 18.9,
				fill: "white"
			})
		}) })
	]
});
export default SvgBarometricPressureIcon;
